export default {
  keyId: 'voiceFanyiWeb',
  product: 'webfanyi',
  signSecretKey: 'qCG2vdP92hOXDcKa',
};
